import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { BsPrinter } from "react-icons/bs";

import { CartonView } from "../../../../../models/carton";
import { Button } from "../../../../Form";
import { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";

interface Props {
  cartons: CartonView[];
  show: boolean;
  loading: boolean;
  selecteds: string[];
  isBookingCancelled?: boolean;

  handleGenerateLabelReport: (cartons: CartonView[]) => void;
}

const PrintLabelButton = (props: Props) => {
  const { show, loading, cartons, selecteds, isBookingCancelled, handleGenerateLabelReport } =
    props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const selectedCartons = useMemo(() => {
    const parsed: CartonView[] = [];

    cartons.forEach((carton, index) => {
      if (selecteds.includes(carton.sscc))
        parsed.push({
          lineId: index,
          ...carton,
        });
    });

    return parsed;
  }, [cartons, selecteds]);

  if (!show) return null;

  const disablePrintButton =
    selectedCartons?.length === 0 ||
    selectedCartons.some((carton) => !carton.isClosed) ||
    isBookingCancelled;

  const handlePrintLabels = () => {
    if (selectedCartons && !!selectedCartons.length) handleGenerateLabelReport(selectedCartons);
  };

  return (
    <DefaultTooltip
      title={disablePrintButton ? translate("allSelectedSsccMustBeClosedToBePrinted") : ""}
    >
      <div>
        <Button
          customColor={Color.SECONDARY_OUTLINED}
          disabled={disablePrintButton}
          onClick={handlePrintLabels}
          loading={loading}
        >
          <div className={classes.printLabelButton}>
            <BsPrinter size={18} />
            <span>{translate("printLabel")}</span>
          </div>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default PrintLabelButton;
